import { ORIGIN_CONFIG, STATUS_CONFIG } from "../constants";

export function StatusPill({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: status || "-",
    color: "#334155",
    bg: "#e2e8f0",
  };
  return (
    <span className="te-status-pill" style={{ color: config.color, backgroundColor: config.bg }}>
      {config.label}
    </span>
  );
}

export function OriginPill({ origin }) {
  const config = ORIGIN_CONFIG[origin] || {
    label: origin || "-",
    color: "#e5e7eb",
    textColor: "#374151",
  };
  return (
    <span
      className="te-origin-pill"
      style={{ backgroundColor: config.color, color: config.textColor }}
    >
      {config.label}
    </span>
  );
}
